<template>
  <div class="numbers"
    :class="{
    'numbers--sravni': this.page === 'sravni',
    'numbers--tablet-fullsize': this.page === 'reqs',
    }">
  <div class="numbers__inputs" @click.stop="clickInputs()">
    <input v-model="input1" ref="input1" type="number" class="numbers__input" placeholder="0" min="0" max="9">
    <input v-model="input2" ref="input2" type="number" class="numbers__input" placeholder="0" min="0" max="9">
    <input v-model="input3" ref="input3" type="number" class="numbers__input" placeholder="0" min="0" max="9">
    <input v-model="input4" ref="input4" type="number" class="numbers__input" placeholder="0" min="0" max="9">
  </div>
    <span class="numbers__alert">
      {{ this.msgAlert}}&nbsp;
    </span>
    <a
      v-if="sendAgainLink"
      @click="this.sendAgain()" 
      class="numbers__link">
      Выслать код подтверждения повторно
    </a>
    <!-- <span 
      v-if="sentAgainMsg" 
      class="numbers__alert"
    >Код отправлен повторно
    </span> -->
    
  </div>
</template>

<script>
export default {
  props: ['msg', 'page'],
  data() {
    return {
      input1: '',
      input2: '',
      input3: '',
      input4: '',
      sendAgainLink: true,
      // sentAgainMsg: false,
      msgAlert: '',
    };
  },
  methods: {
    clickInputs() {
      this.input1 = '';
      this.input2 = '';
      this.input3 = '';
      this.input4 = '';
      this.$refs.input1.focus();
    },
    sendAgain() {
      this.sendAgainLink = false;
      // this.sentAgainMsg = true;
      this.msgAlert = '';

      this.$emit('sendAgain')

      this.input1 = '';
      this.input2 = '';
      this.input3 = '';
      this.input4 = '';

      // setTimeout(() => {
        this.sendAgainLink = true;
        // this.sentAgainMsg = false;
      // }, 1000);
    }
  },
  watch: {
    input1() {
      if (this.input1 !== '') {this.$refs.input2.focus()}
    },
    input2() {
      if (this.input2 !== '') {this.$refs.input3.focus()}
    },
    input3() {
      if (this.input3 !== '') {this.$refs.input4.focus()}
    },
    input4() {
      if (this.input4 !== '') {
        this.$refs.input4.blur();
        
        const numbers = this.input1.toString()
                        + this.input2.toString()
                        + this.input3.toString()
                        + this.input4.toString()
  
        this.$emit('inserted', numbers);
      }
    },
    msg(val) {
      this.msgAlert = val;
      
      this.input1 = '';
      this.input2 = '';
      this.input3 = '';
      this.input4 = '';
    },
  },
}
</script>
<style lang="scss">
@import "@/create/assets/scss/style.scss";

</style>
